"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyType = exports.ECDSA_PATTERNS = void 0;
exports.ECDSA_PATTERNS = {
    secp256k1: {
        PRIVATE_KEY: /^[a-f0-9]{64}$/,
        PUBLIC_KEY: /^[a-f0-9]{66}$/,
        SIGNATURE: /^[a-f0-9]{128}$/,
    },
};
/**
 * Key type specifies, which algorithm has to be used with a particular public key
 */
var KeyType;
(function (KeyType) {
    KeyType["ED25519"] = "Ed25519";
    KeyType["RSA"] = "Rsa";
    KeyType["Secp256k1"] = "Secp256k1";
    KeyType["Secp256r1"] = "Secp256r1";
})(KeyType = exports.KeyType || (exports.KeyType = {}));
//# sourceMappingURL=index.js.map